import { FunctionComponent, memo } from "react";

import styles from "./SectionHeader.module.scss";

import ScorePastille from "@components/generic/scorePastille";
import { useReferential } from "context/referentialContext";

export interface ISectionHeaderProps {
  name: string;
  score: number;
  isBonus: boolean;
}

const SectionHeader: FunctionComponent<ISectionHeaderProps> = ({ name, score, isBonus }) => {
  const { sectionDisplayOptions = {} } = useReferential();
  const { withTextScore = false } = sectionDisplayOptions;
  return (
    <div className={`${styles["section-header"]} section-item`}>
      <h4 className={styles["section-header__title"]}>{name}</h4>
      {!isBonus && (
        <div className={styles["section-header__icons"]}>
          <ScorePastille value={score} {...(withTextScore && { withText: { position: "left" } })} />
        </div>
      )}
    </div>
  );
};

export default memo(SectionHeader);
